import React, { useMemo, useState } from 'react';
import { buildPayFastCheckout, getPayFastSiteOrigin, orderedPayFastFieldEntries } from '../utils/payfastCheckout';

const merchant_id = process.env.REACT_APP_ADMIN_PAYFAST_MERCHANT_ID || '';
const merchant_key = process.env.REACT_APP_ADMIN_PAYFAST_MERCHANT_KEY || '';
const passphrase = process.env.REACT_APP_ADMIN_PAYFAST_PASSPHRASE || '';

const PayfastTest: React.FC = () => {
  const siteOrigin = getPayFastSiteOrigin();
  const [email, setEmail] = useState('testuser@example.com');

  const checkout = useMemo(() => {
    return buildPayFastCheckout({
      merchant_id,
      merchant_key,
      passphrase,
      return_url: `${siteOrigin}/payfast-test?result=success`,
      cancel_url: `${siteOrigin}/payfast-test?result=cancel`,
      notify_url: `${siteOrigin}/payfast-test?result=notify`,
      name_first: 'Test',
      name_last: 'User',
      email_address: email,
      m_payment_id: `test-${Date.now()}`,
      amount: '20.00',
      item_name: 'Test Event',
    });
  }, [siteOrigin, email]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-4">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full text-center">
        <h1 className="text-2xl font-bold mb-4">PayFast Direct Test</h1>
        <p className="mb-6 text-gray-600">
          Test a direct PayFast payment (R20.00) using your production credentials.
        </p>
        <label className="block text-left text-sm text-gray-600 mb-1" htmlFor="payfast-test-email">
          Buyer email (change this to test different buyers)
        </label>
        <input
          id="payfast-test-email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full border border-gray-300 rounded-lg px-3 py-2 mb-4 text-sm"
        />
        <form method="POST" action={checkout.action} target="_blank">
          {orderedPayFastFieldEntries(checkout.fields).map(([key, value]) => (
            <input key={key} type="hidden" name={key} value={value} />
          ))}
          <button
            type="submit"
            className="bg-primary text-white px-6 py-3 rounded-lg font-semibold hover:bg-orange-600 transition-colors w-full mt-4"
          >
            Proceed to PayFast
          </button>
        </form>
        <div className="mt-6 text-xs text-gray-400 text-left space-y-1">
          <div>Merchant ID: {merchant_id || <span className="text-red-500">Not set</span>}</div>
          <div>Merchant Key: {merchant_key ? `${merchant_key.substring(0, 6)}...` : <span className="text-red-500">Not set</span>}</div>
          <div>Passphrase: {passphrase ? 'Set' : <span className="text-yellow-600">Not set</span>}</div>
          <div>PayFast URL: {checkout.action}</div>
          <div>Return URL: {checkout.fields.return_url}</div>
          <div className="break-all">Signature: {checkout.signature}</div>
        </div>
      </div>
    </div>
  );
};

export default PayfastTest;
